import * as React from "react";
import { activeFeatures } from "../utils/FeatureFlags";
import { createContainer } from "./StateContainer";

const useFeatureFlagsContainerState = () => {
  return activeFeatures();
};
const FeatureFlagsContainerState = createContainer(
  useFeatureFlagsContainerState
);

export const FeatureFlagsContainer: React.FC<{
  children?: React.ReactNode;
}> = ({ children }) => {
  return (
    <FeatureFlagsContainerState.Provider>
      {children}
    </FeatureFlagsContainerState.Provider>
  );
};

/**
 * Hook into the current identity context.
 */
export const useFeatureFlags = FeatureFlagsContainerState.useContainer;
